import { useEffect, useState } from 'react';

export default function Thumbnail({ item, index, handleImageClick }) {  
  const [thumbUrl, setThumbUrl] = useState(item?.thumbNail?.default || '');
//   const [thumbUrl, setThumbUrl] = useState('');

  useEffect(() => {
    const width = window.innerWidth;   

    
    if(item.platform === 'uploa'){
      setThumbUrl(item.thumbNail.default);
    }else{
      // Pick the appropriate thumbnail based on screen width
      if (width >= 1200 && item.thumbNail.maxres) {
        setThumbUrl(item.thumbNail.maxres);
      } else if (width >= 992 && item.thumbNail.standard) {
        setThumbUrl(item.thumbNail.standard);
      } else if (width >= 768 && item.thumbNail.high) {
        setThumbUrl(item.thumbNail.high);
      } else if (width >= 576 && item.thumbNail.medium) {
        setThumbUrl(item.thumbNail.medium);
      } else {
        setThumbUrl(item?.thumbNail?.default);
      }
    }    
  }, [item]);

  return (
    <div key={index} style={{ padding: '0 10px' }}>
      <img
        src={thumbUrl}
        alt={`media ${index}`}
        style={{
          width: '100%',
          height: '250px',
          objectFit: 'cover',
          borderRadius: '10px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        }}
        onClick={() => handleImageClick(item)}
      />
    </div>
  );
}
